Pegasus.TemplatePreviewRoute = Ember.Route.extend({
  activate: function(){
    Pegasus.set('loaded', true);
    Pegasus.set('status', 'previewing');
  },
  renderTemplate: function(){
    this.render({
      outlet: 'preview'
    });
  },
  deactivate: function(){
    this._super();

    Pegasus.set('loaded', false);
  },
  actions: {
    didExitPreview: function(){
      Em.set( Pegasus, 'status', 'editing' );
      this.transitionTo('template.index', this.modelFor('template'));
    },
    didSelect: function(){
      Pegasus.get('externalProxy').send('didSelect');
    },
    gotoTemplate: function(){
      Pegasus.set('status', 'editing');
      this.transitionTo('template', this.controllerFor('template').get('content') );
    },
    escape: function(){
      this.send('didExitPreview');
    },
    didLoadTemplate: Em.K
  }
});
